module.exports = __webpack_public_path__ + "static/media/fk.73b91eb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fk.svg
// module id = 113
// module chunks = 0